import { render, staticRenderFns } from "./OrderPhotoItem.vue?vue&type=template&id=7c95dcb0&scoped=true&"
import script from "./OrderPhotoItem.vue?vue&type=script&lang=js&"
export * from "./OrderPhotoItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderPhotoItem.vue?vue&type=style&index=0&id=7c95dcb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c95dcb0",
  null
  
)

export default component.exports